"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DROPDOWN_POSITIONS = exports.DROPDOWN_OPTIONS_DEFAULTS = void 0;
var DROPDOWN_POSITIONS = {
  LEFT: 'left',
  RIGHT: 'right'
};
exports.DROPDOWN_POSITIONS = DROPDOWN_POSITIONS;
var DROPDOWN_OPTIONS_DEFAULTS = {
  HEADER_CONFIG: {
    NORMAL_COLOR: 'greyDarker',
    HOVER_COLOR: 'primary',
    ACTIVE_COLOR: 'primary',
    TEXT_SIZE: 'normal',
    ICON_SIZE: 'medium'
  },
  DROPDOWN_ICON: {
    OPEN: 'ExpandLessIcon',
    CLOSE: 'ExpandMoreIcon'
  },
  DATA_CONFIG: {
    TEXT_COLOR: 'greyDarker',
    BACKGROUND_COLOR: 'default',
    HOVER_BG_COLOR: 'primary',
    TEXT_SIZE: 'normal',
    ICON_SIZE: 'medium'
  },
  POSITION: DROPDOWN_POSITIONS.LEFT
};
exports.DROPDOWN_OPTIONS_DEFAULTS = DROPDOWN_OPTIONS_DEFAULTS;